import { userSegRedirectEntrypoint } from '@jira/redirect-entrypoints__user-seg-redirect/entrypoint.tsx';
import { AsyncHorizontalNavJira } from '@atlassian/jira-horizontal-nav/src/async.tsx';
import { businessProjectLayout } from '@atlassian/jira-business-project-layout/src/index.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarCore from '@atlassian/jira-navigation-apps-sidebar-core/src/async.tsx';
import { ThemedLazySkeleton } from '@atlassian/jira-project-theme-components/src/ui/ThemedLazySkeleton.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getProjectViewResources } from '@atlassian/jira-router-resources-business-common/src/index.tsx';
import { jiraBusinessListRoute } from '@atlassian/jira-router-routes-business-list-routes/src/jiraBusinessListRoute.tsx';
import { listEntryPoint } from '@atlassian/jira-spa-apps-business-list/entrypoint.tsx';
import { jiraHorizontalNavEntrypoint } from '@atlassian/jira-horizontal-nav/entrypoint.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { NIN_NEW_ISSUE_NAVIGATOR } from '@atlassian/jira-capabilities/src/constants.tsx';
import { ProjectIssueNavigatorSkeleton } from '@atlassian/jira-skeletons/src/ui/issue-navigator/components/project-app.tsx';
import { getRouteReporting } from '@atlassian/jira-router-routes-issue-navigator-entries/src/common/getRouteReporting.tsx';
import { issueNavigatorPageEntryPoint } from '@atlassian/jira-router-routes-issue-navigator-entries/src/ui/index.tsx';
import { getCommonProjectResources } from '@atlassian/jira-router-routes-issue-navigator-entries/src/common/getCommonProjectResources.tsx';

const listPageEntryPoint = createPageEntryPoint({
	main: listEntryPoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
	horizontalNavigation: jiraHorizontalNavEntrypoint,
	redirect: userSegRedirectEntrypoint,
});

export const jiraBusinessListRouteEntry = createEntry(jiraBusinessListRoute, () => ({
	group: 'classic-business',
	ufoName: fg('jira_list_nin_merge') ? 'jwm-list-nin' : 'jwm.list-view',
	meta: fg('jira_list_nin_merge')
		? {
				capability: NIN_NEW_ISSUE_NAVIGATOR,
				reporting: getRouteReporting(),
			}
		: undefined,
	layout: businessProjectLayout,
	skeleton: fg('jira_list_nin_merge') ? ProjectIssueNavigatorSkeleton : ThemedLazySkeleton,
	entryPoint: () => (fg('jira_list_nin_merge') ? issueNavigatorPageEntryPoint : listPageEntryPoint),
	navigation: {
		menuId: MENU_ID.PROJECTS,
		// delete when cleaning up getWillShowNav4
		sidebar: AsyncSidebarCore,
		horizontal: AsyncHorizontalNavJira,
	},
	resources: fg('jira_list_nin_merge') ? getCommonProjectResources() : getProjectViewResources(),
	bifrost: {
		bifrostGroup: 'issue-navigator',
		bundling: {
			packageName:
				'@atlassian/jira-router-routes-business-list-entries/src/jiraBusinessListRouteEntry.tsx',
			whichExportToUse: 'jiraBusinessListRouteEntry',
		},
		manifestName: 'jira-spa-issue-navigator.json',
		enabled: true,
	},
	supportsPreviewPanel: true,
	isHydrateRootEnabled: fg('jira_list_nin_merge') ? fg('nin-full-page-hydrate-root') : false,
}));
